<div class="input-carousel">
    <button class="arrow prev" (click)="prev()" [disabled]="!hasPrev()">
        <app-icon [type]="'Arrow-left'"></app-icon>
    </button>
    <input type="text" disabled="disabled" [value]="selectedItem.item" />
    <button class="arrow next" (click)="next()" [disabled]="!hasNext()">
        <app-icon [type]="'Arrow-right'"></app-icon>
    </button>
</div>
